<div class="modal-container">
  <div class="modal-header no-print">
    <h2 mat-dialog-title>
      <mat-icon>print</mat-icon>
      <span>Imprimir Controle de Estoque</span>
    </h2>
    <button mat-icon-button (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content-body modal-print-container">
    @if (isLoading) {
    <div class="loading-container no-print">
      <app-loading-box width="100%" height="300px"></app-loading-box>
    </div>
    }

    @if (linhas.length > 0) {
    <div [hidden]="isLoading">
      <div class="print-title">
        <h2>Controle de Estoque</h2>
      </div>

      <div class="table-responsive">
        <table mat-table [dataSource]="linhas">
          <ng-container matColumnDef="codigoSku">
            <th mat-header-cell *matHeaderCellDef style="width: 14%">Código/SKU</th>
            <td mat-cell *matCellDef="let row">{{ row.isLocal ? '' : row.produto.codigoSku }}</td>
          </ng-container>

          <ng-container matColumnDef="descricao">
            <th mat-header-cell *matHeaderCellDef style="width: 30%">Descrição</th>
            <td mat-cell *matCellDef="let row" [class.local-cell]="row.isLocal">
              @if (row.isLocal) {
              <mat-icon class="local-icon">subdirectory_arrow_right</mat-icon>
              } @else if (row.isVariacao) {
              <span class="variacao-print">
                <mat-icon class="local-icon">subdirectory_arrow_right</mat-icon>
                {{ row.produto.descricao }}
              </span>
              } @else {
              {{ row.produto.descricao }}
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="preco">
            <th mat-header-cell *matHeaderCellDef class="text-end" style="width: 14%">Preço</th>
            <td mat-cell *matCellDef="let row" class="text-end">
              {{ row.isLocal ? '' : (row.produto.preco | abnt:'preco') }}
            </td>
          </ng-container>

          <ng-container matColumnDef="estoque">
            <th mat-header-cell *matHeaderCellDef class="text-end" style="width: 14%">Estoque</th>
            <td mat-cell *matCellDef="let row" class="text-end">{{ getEstoque(row) | abnt:'quantidade' }}</td>
          </ng-container>

          <ng-container matColumnDef="unidade">
            <th mat-header-cell *matHeaderCellDef style="width: 10%">Unidade</th>
            <td mat-cell *matCellDef="let row">{{ row.isLocal ? '' : row.produto.unidade }}</td>
          </ng-container>

          <ng-container matColumnDef="localizacao">
            <th mat-header-cell *matHeaderCellDef style="width: 18%">Localização</th>
            <td mat-cell *matCellDef="let row" [class.local-name]="row.isLocal">{{ getLocalizacao(row) }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.local-row]="row.isLocal"
            [class.variacao-row]="row.isVariacao && !row.isLocal"></tr>
        </table>
      </div>
    </div>
    }

    @if (!isLoading && linhas.length === 0) {
    <div class="text-center p-4">
      <p>Nenhum registro encontrado para os filtros selecionados.</p>
    </div>
    }
  </div>

  <div class="modal-footer no-print">
    <button mat-stroked-button class="btn-secondary" (click)="fechar()">Cancelar</button>
    @if (!isLoading && linhas.length > 0) {
    <button mat-flat-button class="btn-primary" (click)="imprimir()">
      <mat-icon>print</mat-icon> Imprimir
    </button>
    }
  </div>
</div>